import { render, staticRenderFns } from "./SiteMap.vue?vue&type=template&id=85620f2c&scoped=true&"
import script from "./SiteMap.vue?vue&type=script&lang=js&"
export * from "./SiteMap.vue?vue&type=script&lang=js&"
import style0 from "./SiteMap.vue?vue&type=style&index=0&id=85620f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85620f2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
